import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendSharingService } from './extend-sharing.service';
import { ExtendSharingContainerComponent } from './extend-sharing-container/extend-sharing-container.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { UIRouterModule } from '@uirouter/angular';
import { ExtendSharingStates } from '@fi-app/components/extend-sharing/extend-sharing-states';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { ExtendSharingContentComponent } from './extend-sharing-content/extend-sharing-content.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { ExtendSharingObjectComponent } from '@fi-app/components/extend-sharing/extend-sharing-object/extend-sharing-object.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        UIRouterModule.forChild(ExtendSharingStates),
        FiButtonBackNewModule,
        MatCardModule,
        MatCheckboxModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        FiLoadingModule,
        FiPageHeaderModule,
        MatIconModule,
    ],
    declarations: [ExtendSharingContainerComponent, ExtendSharingContentComponent, ExtendSharingObjectComponent],
    providers: [ExtendSharingService],
    exports: [ExtendSharingObjectComponent],
})
export class ExtendSharingModule {}
